import { createReducer, on } from '@ngrx/store';

import { CROSS_SELLING_STORE_API_ACTIONS } from './cross-selling.action';
import { CROSS_SELLING_STORE_INITIAL_STATE, CrossSellingState } from './cross-selling.state';

export const CROSS_SELLING_STORE_REDUCER = createReducer(
  CROSS_SELLING_STORE_INITIAL_STATE,

  // API Actions
  on(CROSS_SELLING_STORE_API_ACTIONS.loadCrossSellingLoading, (state): CrossSellingState => ({
    ...state,
    isLoading: true,
    hasError: false,
    error: null,
  })),

  on(CROSS_SELLING_STORE_API_ACTIONS.loadCrossSellingSuccess, (state, data): CrossSellingState => ({
    ...state,
    data,
    isLoading: false,
    isLoaded: true,
    hasError: false,
    error: null,
  })),

  on(
    CROSS_SELLING_STORE_API_ACTIONS.loadCrossSellingFailure,
    (state, { error }): CrossSellingState => ({
      ...state,
      isLoading: false,
      hasError: true,
      error,
    }),
  ),
);
